export function formatChartPercent(percentDecimals: number | undefined) {
    if (percentDecimals === undefined) return "";
    return Math.round(percentDecimals * 100) + "%";
}
